import React from "react";
import "./Header.css";

import { HackZurich, HolcimLogo } from "../../globals/utils";

const Header = () => {
  return (
    <div className="fixed-header">
      <div className="header-imgs">
        <img
          src={HackZurich}
          alt="HackZurich2021"
          className="header-title-img"
        />
        <img src={HolcimLogo} alt="HolcimLogo" className="header-title-img" />
      </div>
      <p className="header-p">
        Smart and cost effective way of Combating Construction Chaos"{" "}
      </p>
    </div>
  );
};

export default Header;
